<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p26"><span><a id="page_21"></a><a href="#/Contents#rp26">GREEN ONION-POTATO SOUP WITH DILL</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Very simple, and very good. Use fresh dill for best flavor.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>2½ cups chopped green onions</span></p>
<p class="hang"><span>1 tablespoon margarine or butter</span></p>
<p class="hang"><span>2 tablespoons flour</span></p>
<p class="hang"><span>1½ quarts fat-free chicken broth, divided</span></p>
<p class="hang"><span>1¾ cups cubed, peeled potatoes</span></p>
<p class="hang"><span>2 tablespoons finely chopped fresh or 1 tablespoon dried dill weed</span></p>
<p class="hang"><span>¼ cup low-fat plain yogurt</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté onions in margarine in large saucepan until tender, about 5 minutes. Stir in flour and cook 1 minute. Stir in 3 cups broth, potatoes, and dill; heat to boiling; reduce heat and simmer, covered, until potatoes are tender, about 10 minutes. Process 1 cup soup in food processor or blender until smooth; add 1 cup broth and yogurt and process until smooth. Return soup to saucepan; add enough remaining 2 cups broth to make desired consistency. Heat to simmering; simmer, uncovered until hot, 3 to 4 minutes. Season to taste with salt and white pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 105</span></p>
<p class="per1"><span>% calories from fat: 16</span></p>
<p class="per1"><span>Protein (g): 6.2</span></p>
<p class="per1"><span>Carbohydrate (g): 16.6</span></p>
<p class="per1"><span>Fat (g): 1.9</span></p>
<p class="per1"><span>Saturated fat (g): 0.4</span></p>
<p class="per1"><span>Cholesterol (mg): 0.5</span></p>
<p class="per1"><span>Sodium (mg): 316</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter028.vue?12bcb5af